import { ReactElement } from 'react';
import { Heading } from '@appsumo/dorado-react';

import { currencyWithCents } from '~/lib/format';
import { DiscountDataType } from '~/types/account';

export default function AccountCredits({
  discountData,
}: {
  discountData?: DiscountDataType;
}): ReactElement {
  return (
    <div className="mb-4 flex flex-col gap-y-2 border-b border-sundog pb-4">
      <Heading.H3>Credits</Heading.H3>
      <p>
        Credits don&apos;t expire and can be applied at checkout. Balance cannot
        be shared to another account or person.
      </p>
      <p className="font-medium">Your current AppSumo credit balance is:</p>
      <p className="text-xl font-medium text-money-moss">
        {currencyWithCents(discountData?.credit_amount || 0)}
      </p>
    </div>
  );
}
